import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContractBriefReportComponent } from '../pages/contract-brief-report/contract-brief-report.component';
import { DigisubservicesService } from '../services/digisubservices.service';
import { AdvertisementDetailsComponent } from '../pages/advertisement-details/advertisement-details.component';
import { MatOption, MatSelect } from '@angular/material/select';
import { BookSellerRegistrationComponent } from '../pages/book-seller-registration/book-seller-registration.component';


@Component({
  selector: 'app-open-issue-seller-credit-note',
  templateUrl: './open-issue-seller-credit-note.component.html',
  styleUrl: './open-issue-seller-credit-note.component.scss'
})

export class OpenIssueSellerCreditNoteComponent implements OnInit {
  myForm: FormGroup;
  advtCreditNoteModal: any;
  contractData: {};
  contractOffRepName: any;
  uniqueid: any;
  contractRepName: any;
  contractAdvtName: any;
  repname: any;

 
  constructor(private dialogRef: MatDialogRef<OpenIssueSellerCreditNoteComponent>,
  @Inject(MAT_DIALOG_DATA) public data: any,
  private service: DigisubservicesService,
  private cdr: ChangeDetectorRef,private fb: FormBuilder,public activeModal: MatDialogRef<BookSellerRegistrationComponent>,
  @Inject(MAT_DIALOG_DATA) public data1: any
)
 {

  }

  ngOnInit(): void {
    this.replist();
   
    this.myForm = this.fb.group({
      CreitVC: ['', Validators.required],
      invcnum: ['', Validators.required],
      invcamt: ['', Validators.required],    
      invcdate: ['', Validators.required],           
      advtname: ['', Validators.required],
      advtno: ['', Validators.required],
      crndate: ['', Validators.required],
      Vcdate: ['', Validators.required],
      CRamt: ['', Validators.required],
      Repname: ['', Validators.required],
      remark: ['', Validators.required],
      Crtype: ['', Validators.required],
      otherAmt: ['', Validators.required],
      tdsAmt: ['', Validators.required],
      issuenum: ['', Validators.required],
      copies:['', Validators.required],
      price:['', Validators.required],
      crdcopies:['', Validators.required],
      
    });

    debugger
  this.myForm.patchValue({
    CreitVC:  this.data['cr_vocher'],
      invcnum: this.data['invoice_no'],
      invcamt: this.data['issue_amt'],
      invcdate: this.data['invoice_date'],
      advtname: this.data['advt_name1'],
      issuenum: this.data['issue_id'],
      crndate: this.data['create_date'],
      Vcdate:this.data['receipt_date'],
      CRamt: this.data['remainvalue'],
      Repname: this.data['rep_name'],
      copies:this.data['copies'],
      crdcopies:this.data['crdcopies'],
      price:this.data['price'],
      remark: null,
      Crtype: null,
  })
   this.setupAutoCreditCalculation();
  }
   //date format
  formatDateToYYYYMMDD(dateStr: string): string {
    const [day, month, year] = dateStr.split('-');
    return `${year}-${month}-${day}`;
  }

 getModaldata() {
  const req = {
    data: {
      credit_note_no: this.myForm.value.CreitVC,
      invoice_no: this.myForm.value.invcnum,
      issue_no: this.myForm.value.issuenum,
      invoice_amt: this.myForm.value.invcamt,
      invoice_date: this.formatDateToYYYYMMDD(this.myForm.value.invcdate),
      issue_seller_name: this.myForm.value.advtname,
      creation_date: this.myForm.value.crndate,
      credit_note_date: this.formatDateToYYYYMMDD(this.myForm.value.Vcdate),
      creadit_note_amt: this.myForm.value.CRamt,
      credit_type: this.myForm.value.Crtype,
      representative_name: this.myForm.value.Repname,
      remark: this.myForm.value.remark,
      copies: this.myForm.value.copies,
      crdcopies: this.myForm.value.crdcopies,
      price: this.myForm.value.price,
      credit_count: this.data['credit_count'],
    }
  };

  this.service.getCreditNoteModalissue(req).subscribe((data: any) => {
    if (data && data.message) {
      alert(data.message);
    }

    this.dialogRef.close(true); // ✅ Return success to parent
    
    this.myForm.reset();
  });
}

  setupAutoCreditCalculation() {
  this.myForm.get('crdcopies')!.valueChanges.subscribe(() => {
    this.updateCreditNoteAmount();
  });

  this.myForm.get('price')!.valueChanges.subscribe(() => {
    this.updateCreditNoteAmount();
  });
}

updateCreditNoteAmount() {
  const crdcopies = parseFloat(this.myForm.get('crdcopies')!.value) || 0;
  const price = parseFloat(this.myForm.get('price')!.value) || 0;

  const creditNoteAmount = crdcopies * price;
  this.myForm.get('CRamt')!.setValue(creditNoteAmount.toFixed(2), { emitEvent: false });
}


  id:any
  closeModalWithResult() {
    const dataToSend = {
      key1: this.id,
      credit_type: this.myForm.value.Crtype,
      remark : this.myForm.value.remark
      // Add more key-value pairs as needed
    };
    this.activeModal.close(dataToSend);
  }

  replist() {
    this.service.getNewRepList().subscribe((data:any) => {
       
       this.repname = (data as any);;

       console.log("replist", this.repname);

  
    });
  }



  getallcontarctdetails() {
    this.service.getissueAllContractDetails().subscribe((res) => {
      // console.log(res);
      this.contractData = res;
      this.getContractDetails();
      console.log(res);
    });
  }
  contractReportRepName = '';
  getContractRepName(event) {
    this.contractReportRepName = event.value;
  }


  getContractDetails() {
    for (
      let index = 0;
      index < Object.keys(this.contractData).length;
      index++
    ) {
      this.contractRepName.push({
        name: this.contractData[index]['rep_name'],
      });
      this.contractOffRepName.push({
        name: this.contractData[index]['off_rep_name'],
      });
      this.contractAdvtName.push({
        name: this.contractData[index]['advt_name'],
      });
    }

    this.contractRepName = this.uniqueid(this.contractRepName, (a) => a.name);
    this.contractOffRepName = this.uniqueid(
      this.contractOffRepName,
      (a) => a.name
    );
    this.contractAdvtName = this.uniqueid(this.contractAdvtName, (a) => a.name);
  }

  allSelected = false;
  @ViewChild('mySel') skillSel: MatSelect;
  toggleAllSelection() {
    this.allSelected = !this.allSelected; // to control select-unselect
    // console.log(this.skillSel.options);
    if (this.allSelected) {
      this.skillSel.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSel.close();
  }
}
